<template>
  <v-chip
    class="ma-2 custom-status font-weight-500 text-uppercase custom-grey-border"
    :small="small"
    text-color="white"
    color="green"
    v-if="status"
    label
  >
    Active
  </v-chip>
  <v-chip
    class="ma-2 custom-status font-weight-500 text-uppercase custom-grey-border"
    :small="small"
    text-color="white lighten-1"
    color="red lighten-1"
    v-else
    label
  >
    In-Active
  </v-chip>
</template>

<script>
export default {
  props: {
    status: {
      type: Boolean,
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
